import React from 'react';
import { useTranslation } from 'react-i18next';
import { Award } from 'lucide-react';
import { communicationBadgeTitleKey, type CommBadgeItem } from '../../utils/gamification';

type Props = {
  badges: CommBadgeItem[];
  emptyMessageKey?: string;
  className?: string;
  chipClassName?: string;
};

export function CommunicationBadgeChips({
  badges,
  emptyMessageKey = 'gamification.badges.keepPracticing',
  className = '',
  chipClassName = '',
}: Props) {
  const { t } = useTranslation();
  const earned = badges.filter((b) => b.badge_key);

  if (!earned.length) {
    return (
      <p className={`text-xs text-slate-600 dark:text-slate-400 ${className}`}>{t(emptyMessageKey)}</p>
    );
  }

  return (
    <div className={`flex flex-wrap gap-2 ${className}`}>
      {earned.map((b, i) => (
        <span
          key={`${b.badge_key}-${i}`}
          className={`inline-flex items-center gap-1.5 text-xs font-medium px-3 py-1 rounded-full bg-white/90 dark:bg-slate-800 border border-purple-200 dark:border-purple-700 text-app-primary dark:text-purple-100 ${chipClassName}`}
        >
          <Award className="w-3.5 h-3.5 shrink-0 text-amber-500" aria-hidden />
          <span className="tamil-text" lang="ta">
            {t(communicationBadgeTitleKey(b.badge_key))}
          </span>
        </span>
      ))}
    </div>
  );
}
